import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';

export const templateMaintenanceWindowForm = document.createElement('template');

templateMaintenanceWindowForm.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">

    <div class="loading-container">
      <gz-progress-spinner size="large"></gz-progress-spinner>
    </div>

    <gz-image-repo state="error" class="loading-error">
      <gz-text fontSize="14" fontWeight="400" class="loading-error--message" />
    </gz-image-repo>

    <div class="form-wrapper">

      <div class='form-section'>
        <gz-title class="title" fontweight="500" fontsize="18" id="maintenance-type-title"></gz-title>
        <gz-form-field id="window-name-form-field" class='label-mw-250' label='' required>
          <gz-input gz-form-input placeholder="" inputwidth="240"></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id='maintenance-window-type-form-field' label='' class='label-mw-250 hidden' required>
          <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id="others-can-make-changes-form-field" class='label-mw-250'>
          <gz-toggle gz-form-input></gz-toggle>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>

      <gz-maintenance-window-form-patch-specifics></gz-maintenance-window-form-patch-specifics>
    </div>

    <div class="bottom-buttons">
        <gz-button id="btnSave" disabled></gz-button>
        <gz-button id="btnCancel" type="outline" color="secondary"></gz-button>
    </div>
  </div>
`;
